module.exports = __webpack_public_path__ + "static/media/suki.cec499ce.png";